import { z } from "zod"

const NUMBER_TYPE_ERROR_MESSAGE = "is required"

export const shippingCostEstimatorFormStateSchema = z
  .object({
    baseMarginPercentage: z.number(NUMBER_TYPE_ERROR_MESSAGE).int().positive(),
    allowedCarriers: z.enum(["exclude_economy", "no_restrictions"]),
    shippingKit: z.enum(["corrugated_box", "padded_mailer", "no_additional_packaging", "custom_packaging"]),
    customPackagingWeight: z.number().positive().optional(),
    destinations: z
      .array(
        z.object({
          key: z.unknown().optional(),
          alpha2: z.string("required"),
          zoning: z.enum(["commercial", "residential"]),
          quantity: z.number(NUMBER_TYPE_ERROR_MESSAGE).int().min(1),
          carrier: z.string().optional(),
          service: z.string().optional(),
        })
      )
      .min(1),
    packageDimension: z
      .object({
        weight: z.number(NUMBER_TYPE_ERROR_MESSAGE).positive().optional(),
        length: z.number(NUMBER_TYPE_ERROR_MESSAGE).positive().optional(),
        width: z.number(NUMBER_TYPE_ERROR_MESSAGE).positive().optional(),
        height: z.number(NUMBER_TYPE_ERROR_MESSAGE).positive().optional(),
      })
      .optional(),
    variants: z
      .array(
        z.object({
          id: z.number().int().positive(),
          quantity: z.number(NUMBER_TYPE_ERROR_MESSAGE).int().min(1),
          productId: z.unknown().optional(),
          productName: z.unknown().optional(),
          unitWeightOz: z.number().positive(),
          key: z.unknown().optional(),
        })
      )
      .min(1),
    timeWindow: z.enum(["most_economical_rate", "by_certain_date"]),
    byDays: z.number(NUMBER_TYPE_ERROR_MESSAGE).int().min(1).optional(),
  })
  .superRefine((data, ctx) => {
    // Conditional validation: customPackagingWeight required when shippingKit is custom_packaging
    if (data.shippingKit === "custom_packaging" && !data.customPackagingWeight) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["customPackagingWeight"],
        message: "customPackagingWeight is required",
      })
    }

    // Conditional validation: byDays required when timeWindow is by_certain_date
    if (data.timeWindow === "by_certain_date" && !data.byDays) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["byDays"],
        message: "byDays is required",
      })
    }
  })
